/* eslint-disable no-shadow */
// src/store/googleAuth.js
import { Auth } from 'aws-amplify';

const state = () => ({
  checkingGoogleAuth: true,
  authenticatedWithGoogle: false,
  googleEmail: '',
  checkingMicrosoftAuth: true,
  authenticatedWithMicrosoft: false,
  microsoftEmail: '',
  cgsURL: 'https://tc3.dasvideolab.cloud:8000',
});

const mutations = {
  setCheckingGoogleAuth(state, value) {
    state.checkingGoogleAuth = value;
  },
  setAuthenticatedWithGoogle(state, value) {
    state.authenticatedWithGoogle = value;
  },
  setGoogleEmail(state, value) {
    state.googleEmail = value;
  },
  setCheckingMicrosoftAuth(state, value) {
    state.checkingMicrosoftAuth = value;
  },
  setAuthenticatedWithMicrosoft(state, value) {
    state.authenticatedWithMicrosoft = value;
  },
  setMicrosoftEmail(state, value) {
    state.microsoftEmail = value;
  },
};

const actions = {
  async checkAuthenticatedWithGoogle({ commit, state }) {
    console.log('[Debug] Checking Google authentication status...');
    try {
      const user = await Auth.currentAuthenticatedUser();
      const idToken = user.getSignInUserSession().getAccessToken().getJwtToken();
      const response = await fetch(`${state.cgsURL}/oauth/status`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      });
      const data = await response.json();
      commit('setAuthenticatedWithGoogle', data.google.logged_in);
      commit('setGoogleEmail', data.google.email);
      commit('setCheckingGoogleAuth', false);
      commit('setAuthenticatedWithMicrosoft', data.microsoft.logged_in);
      commit('setMicrosoftEmail', data.microsoft.email);
      commit('setCheckingMicrosoftAuth', false);
    } catch (error) {
      commit('setCheckingGoogleAuth', false);
      commit('setAuthenticatedWithGoogle', false);
      commit('setGoogleEmail', '');
      commit('setCheckingMicrosoftAuth', false);
      commit('setAuthenticatedWithMicrosoft', false);
      commit('setMicrosoftEmail', '');
      console.error('[Error] Failed to check Google authentication:', error);
    }
  },
  async signInWithGoogle({ state }) {
    const user = await Auth.currentAuthenticatedUser();
    if (user) {
      window.location.href = `${state.cgsURL}/oauth/login?cognito_sub=${user.username}`;
    }
  },
  async signOutGoogle({ state }) {
    const user = await Auth.currentAuthenticatedUser();
    window.location.href = `${state.cgsURL}/oauth/logout?cognito_sub=${user.username}`;
  },
  async signInWithMicrosoft({ state }) {
    const user = await Auth.currentAuthenticatedUser();
    if (user) {
      window.location.href = `${state.cgsURL}/oauth/microsoft/login?cognito_sub=${user.username}`;
    }
  },
  async signOutMicrosoft({ state }) {
    const user = await Auth.currentAuthenticatedUser();
    window.location.href = `${state.cgsURL}/oauth/microsoft/logout?cognito_sub=${user.username}`;
  },
};

const getters = {
  checkingGoogleAuth: (state) => state.checkingGoogleAuth,
  authenticatedWithGoogle: (state) => state.authenticatedWithGoogle,
  googleEmail: (state) => state.googleEmail,
  authenticatedWithMicrosoft: (state) => state.authenticatedWithMicrosoft,
  microsoftEmail: (state) => state.microsoftEmail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
